import React, {useState, useEffect, Fragment} from 'react'
import ProgressTrackerContainer from '../Widgets/ProgressTracker/progress_tracker_container'
import LatestNotificationsContainer from '../Widgets/LatestNotifications/latest_notifications_container'
import DevicesWidgetContainer from '../Widgets/Devices/devices_widget_container'
import WorkInstructionsOverviewContainer from '../Widgets/Work Instructions Overview/work_instructions_overview_container'
import axios from "axios"
//component renders the widget the user is subscribed to/authorized to see.
//In the future, we will make the widget both customizable in size and selection.

const Feed = (props) => {
    const signal = axios.CancelToken.source()
    const [isLoading, setIsLoading] = useState(true)
    const currentUser = props.currentUser
    const currentUserId = props.currentUserId
    const notifications = props.notifications
    
    useEffect(() => {
        props.fetchAllUsers(signal.token)
        props.fetchIncomingNotifications(currentUserId)
        setIsLoading(false)
      }, []
    )

    return (
    <div id="feed-container" className="flex max-height">
        {["Dev", "Work Lead", "Shop Supervisor"].includes(currentUser.role) 
            ? 
                <Fragment>
                    {/* <LatestNotificationsContainer gridlabel={"noti"} users={props.users} fromBell={false}/>
                    <DevicesWidgetContainer gridlabel={"devices"} /> */}
                    <WorkInstructionsOverviewContainer gridlabel={"wi"} users={Object.values(props.users)}/>
                    <ProgressTrackerContainer gridlabel={"users"} users={Object.values(props.users)}/>
                    
                </Fragment>
            : 
                <div>You are not currently subscribed to any widgets</div>}
        </div>
    )
}

export default Feed
